module.exports = __webpack_public_path__ + "img/m-topic@2x.fab7d772.png";